import styled from 'styled-components';
import { colors, Row, Cell } from '@dexma/ui-components';

export const StyledRangeContainer = styled.div`
    padding: 10px 30px 0px 30px;

    .widget-type-block span {
        font-weight: 700;
        color: ${colors.gray700};
    }

    .error {
        color: ${colors.red};
        text-align: left;
    }
`;

export const StyledResetRangeContainer = styled(Cell)`
    display: flex;
    justify-content: end;
`;

export const StyledRemoveElementContainer = styled(Cell)`
    display: flex;
    place-content: center;
    margin: 2rem 0rem;
`;

export const StyledRemoveRangeButton = styled(Row)`
    position: absolute;
    right: 2.75rem;
    margin-top: 0.5rem;
    z-index: 1;
    rotate: 45deg;
`;

export const StyledCellRangeGroupContainer = styled.div`
    background-color: #f7f9fa;
    padding-bottom: 2rem;
    margin-top: 1rem;
`;
